/**
 * @desc 取消交货单
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.inPlanFacadeImpl.deleteInPlanMaster.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inPlan/deleteInPlanMaster`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
